import { LocalizedDateFromUtc } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { Typography } from '@optimus-web/core';

export const ExpirationDate = ({ expirationDate }: { expirationDate?: string }) => (
    <Typography textStyle="bodyMedium" as="div">
        {expirationDate != null ? <LocalizedDateFromUtc utcString={expirationDate} /> : UnicodeEntity.Dash}
    </Typography>
);
